import React from "react";
import { AlertTriangle, Video, FileText, LifeBuoy } from "lucide-react";

export const IntegrityFooter = () => {
    return (
        <footer
            className="relative py-20 md:py-28 bg-[#0B1325]"
            data-testid="integrity-footer"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div
                    className="relative border border-[#FF5A00]/40 bg-[#FF5A00]/[0.04] backdrop-blur-md p-8 md:p-12 mb-16"
                    data-testid="integrity-notice"
                >
                    <span className="absolute top-2 left-2 w-3 h-3 border-t border-l border-[#FF5A00]" />
                    <span className="absolute top-2 right-2 w-3 h-3 border-t border-r border-[#FF5A00]" />
                    <span className="absolute bottom-2 left-2 w-3 h-3 border-b border-l border-[#FF5A00]" />
                    <span className="absolute bottom-2 right-2 w-3 h-3 border-b border-r border-[#FF5A00]" />

                    <div className="flex flex-col md:flex-row items-start gap-6">
                        <div className="w-14 h-14 border border-[#FF5A00]/50 bg-[#FF5A00]/10 flex items-center justify-center shrink-0">
                            <AlertTriangle size={22} className="text-[#FF5A00]" />
                        </div>
                        <div className="flex-1">
                            <div className="text-[10px] uppercase tracking-[0.4em] font-bold text-[#FF5A00] mb-3">
                                ⚠ Competitive Integrity Notice
                            </div>
                            <h3 className="font-display font-black text-white text-2xl md:text-3xl uppercase tracking-tight leading-tight mb-4">
                                No Video. No Verification. No Payout.
                            </h3>
                            <p className="text-[#94A3B8] text-sm md:text-base leading-relaxed max-w-3xl">
                                While scores are initially logged via smartphone screenshot
                                uploads within the mobile app, players{" "}
                                <span className="text-white font-semibold">
                                    must submit corresponding, unedited video footage
                                </span>{" "}
                                of their entire round for independent review. No prize payouts —
                                including the{" "}
                                <span className="text-[#D4AF37] font-semibold font-mono-num">
                                    $50,000.00
                                </span>{" "}
                                Grand Prizes or{" "}
                                <span className="text-[#D4AF37] font-semibold font-mono-num">
                                    $1,000.00
                                </span>{" "}
                                Hole-in-One Bounties — will be distributed without full,
                                independent verification clearance.
                            </p>

                            <div className="flex flex-wrap gap-3 mt-6">
                                <a
                                    href="#"
                                    data-testid="footer-upload-video"
                                    className="inline-flex items-center gap-2 border border-[#FF5A00] text-[#FF5A00] hover:bg-[#FF5A00]/10 font-bold uppercase tracking-[0.2em] text-[11px] px-5 py-3 transition-colors"
                                >
                                    <Video size={14} />
                                    Upload Round Footage
                                </a>
                                <a
                                    href="#"
                                    data-testid="footer-rules-doc"
                                    className="inline-flex items-center gap-2 border border-white/20 text-white/80 hover:border-white/40 hover:text-white font-bold uppercase tracking-[0.2em] text-[11px] px-5 py-3 transition-colors"
                                >
                                    <FileText size={14} />
                                    Full Rules PDF
                                </a>
                                <a
                                    href="#"
                                    data-testid="footer-support"
                                    className="inline-flex items-center gap-2 border border-white/20 text-white/80 hover:border-white/40 hover:text-white font-bold uppercase tracking-[0.2em] text-[11px] px-5 py-3 transition-colors"
                                >
                                    <LifeBuoy size={14} />
                                    Player Support
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom bar */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 pt-10 border-t border-white/10">
                    <div className="flex items-center gap-3">
                        <div className="w-8 h-8 border border-[#D4AF37] flex items-center justify-center">
                            <span className="font-display font-black text-[#D4AF37] text-sm">
                                A
                            </span>
                        </div>
                        <div className="font-display text-xs font-bold tracking-[0.25em] uppercase text-white">
                            Apex Majors <span className="text-[#D4AF37]">/</span>{" "}
                            <span className="text-[#94A3B8]">Trackman Series</span>
                        </div>
                    </div>
                    <div className="text-[10px] uppercase tracking-[0.3em] text-[#475569]">
                        © {new Date().getFullYear()} Apex Majors. All rounds independently
                        verified.
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default IntegrityFooter;
